<template>
    <figure class="icon-columns">
        <div
            v-for="(block, index) in grid"
            :key="index"
            class="icon-columns__block"
            :class="[block.class, displayClass(block)]"
        >
            <span class="icon-columns__label">{{ block.width }}</span>
        </div>
    </figure>
</template>

<script>
/* eslint-disable no-eval */
import { reduceFraction } from '@/utils/math';

export default {
    name: 'icon-columns',

    props: {
        layout: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            grid: [],
        };
    },

    computed: {
        numRows() {
            const totalPercentage = this.grid.reduce((total, curr) => {
                const currNum = Number(curr.width.slice(0, -1));

                return total + currNum;
            }, 0);

            return Math.round(totalPercentage / 100);
        },
    },

    mounted() {
        this.grid = this.layout.map(fraction => ({
            class: `f-w-${ reduceFraction(fraction) }`,
            width: `${ Math.floor(eval(fraction) * 100) }%`,
        }));
    },

    methods: {
        displayClass() {
            return `icon-columns__block--${ this.numRows }`;
        },
    },
};
</script>

<style lang="scss">
.icon-columns {
    display: flex;
    flex-wrap: wrap;
    border-right: 1px solid black;
    border-bottom: 1px solid black;

    &__block {
        position: relative;
        padding-bottom: 50%;
        border-left: 1px solid black;
        border-top: 1px solid black;

        &--2 { padding-bottom: 25%; }
        &--3 { padding-bottom: 16.6666667%; }
        &--4 { padding-bottom: 12.5%; }
        &--5 { padding-bottom: 10%; }
        &--6 { padding-bottom: 8.3333333%; }

        &:nth-of-type(odd) {
            background-color: $column-preview-odd-color;
        }

        &:nth-of-type(even) {
            background-color: $column-preview-even-color;
        }
    }

    &__label {
        @extend %center-middle;
        font-size: 12px;
        color: $column-preview-label-color;
    }
}
</style>
